import React from "react";
import { Link } from "react-router-dom";
import { Plus, Route } from "lucide-react";
import { TspBreadcrumb, TspEmptyState } from "../../components/primitives";
import TspLoadError from "../../components/common/TspLoadError";
import { LIST_STATUS_FILTERS } from "../../constants/tspJourneyStatus";
import useTspJourneysListData, { emptyJourneysMessage } from "./useTspJourneysListData";
import JourneyCoverageMap from "./components/JourneyCoverageMap";
import JourneyFilters from "./components/JourneyFilters";
import PastJourneysTable, { PastJourneysTitle } from "./components/PastJourneysTable";
import ThisYearStatsPanel from "./components/ThisYearStatsPanel";

const NO_OPTIONS = { teams: [], states: [], temples: [], years: [] };

export default function TspJourneysPage() {
  const { places, summary, filters, applyFilters, setPage } = useTspJourneysListData();
  const summaryData = summary.data;

  const renderList = () => {
    if (places.error) return <TspLoadError error={places.error} onRetry={places.reload} what="journey places" />;
    if (!places.data) return <div className="tsp-page tsp-dashboard-loading">Loading journey places…</div>;
    if (places.data.length === 0) {
      return <TspEmptyState icon={Route} title="No journey places found" message={emptyJourneysMessage(filters)} />;
    }
    return <PastJourneysTable rows={places.data} meta={places.meta} onPageChange={setPage} />;
  };

  return (
    <div className="tsp-page tsp-journeys-page">
      <div className="tsp-page-heading-row">
        <div>
          <h1>Journey Management</h1>
          <TspBreadcrumb items={["Dashboard", "Journeys"]} />
        </div>
        <Link to="/tsp/journeys/new" className="tsp-btn tsp-btn-success tsp-btn-pill">
          <Plus size={15} /> Create New Journey
        </Link>
      </div>

      <JourneyFilters applied={filters} options={summaryData?.filter_options || NO_OPTIONS} onApply={applyFilters} />

      {summary.error && <TspLoadError error={summary.error} onRetry={summary.reload} what="the coverage summary" />}
      {summaryData && <JourneyCoverageMap coverage={summaryData.coverage} year={filters.year} filters={filters} />}

      <div className="tsp-journeys-lower">
        <PastJourneysTitle title={LIST_STATUS_FILTERS[filters.status].label} totals={places.meta?.totals || summaryData?.totals || { completed: 0, cancelled: 0 }} />
        {renderList()}
        {summaryData && (
          <ThisYearStatsPanel
            stats={{
              ...summaryData.this_year,
              completed: places.meta?.totals?.completed ?? summaryData.this_year.completed,
              total_journeys: places.meta?.total ?? summaryData.this_year.total_journeys,
              cancelled: places.meta?.totals?.cancelled ?? summaryData.this_year.cancelled,
            }}
          />
        )}
      </div>
    </div>
  );
}
